import { Field, FieldProps } from 'formik';
import { FC } from 'react';
import { CheckBoxInputType } from '../../checkbox';
export const CheckToggle = (props: CheckBoxInputType) => {
  const CustomField: FC<FieldProps> = ({ ...formikFieldProps }) => {
    return (
      <div className={`flex items-center gap-2`}>
        <input
          {...formikFieldProps.field}
          {...formikFieldProps.meta}
          type="checkbox"
          className={`accent-green-300 text-white bg-grey-100 cursor-pointer`}
          style={{
            backgroundColor: '#eee',
            boxShadow: 'inset 0px 2px 2px rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            color: '#ffffff',
            height: '20px',
            width: '20px',
            border: 'none',
          }}
          id={props.name}
          checked={formikFieldProps.field.value}
        />
        <label htmlFor={props.name}>
          {props.label}
        </label>
      </div>
    );
  };

  return <Field name={props.name} component={CustomField} />;
};
